<script lang="ts">
	export let cls = 'block w-12 h-12';
</script>

<svg class={cls} viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M697.831 853.021L594.086 956.336L586.144 927.196L666.77 846.89L696.822 852.77C697.164 852.833 697.5 852.917 697.831 853.021Z"
		fill="#00E8FC"
	/>
	<path
		d="M706.815 864.342L707.6 880.361L616.556 971.042L602.07 965.743C598.293 964.362 595.426 961.237 594.367 957.359L594.084 956.335L697.828 853.019C702.904 854.45 706.55 858.986 706.815 864.342Z"
		fill="#2DD881"
	/>
	<path
		d="M707.598 880.361L709.34 915.701L643.769 980.998L616.557 971.042L707.598 880.361Z"
		fill="#C9F180"
	/>
	<path
		d="M666.769 846.89L586.144 927.197L578.19 898.041L634.915 841.542C636.439 841.267 638.003 841.268 639.544 841.568L666.769 846.89Z"
		fill="#F9C846"
	/>
	<path
		d="M709.341 915.701L710.503 939.4C710.699 943.437 708.915 947.319 705.719 949.796L663.946 982.207C660.585 984.817 656.12 985.511 652.132 984.054L643.77 980.997L709.341 915.701Z"
		fill="#FF595F"
	/>
	<path
		d="M634.916 841.542L578.19 898.041L574.645 885.03C573.14 879.512 575.597 873.69 580.583 870.93L631.19 842.887C632.365 842.235 633.623 841.787 634.916 841.542Z"
		fill="#8F41B0"
	/>
	<path
		d="M693.688 874.984L696.57 933.638C696.723 936.792 695.331 939.825 692.837 941.762L660.192 967.091C657.564 969.126 654.077 969.67 650.958 968.525L611.844 954.223C608.898 953.143 606.652 950.707 605.827 947.672L590.412 891.152C589.242 886.847 591.157 882.298 595.052 880.137L634.595 858.226C636.583 857.128 638.897 856.761 641.124 857.199L685.882 865.947C690.248 866.806 693.467 870.534 693.688 874.984Z"
		fill="#BD8FD1"
	/>
	<path
		d="M660.611 933.562C660.838 934.858 660.591 936.032 659.874 937.085C659.155 938.138 658.228 938.766 657.092 938.965C656.333 939.097 655.581 938.98 654.836 938.619C654.088 938.258 653.436 937.601 652.882 936.654L646.639 926.081L621.637 930.451L619.355 942.513C619.153 943.592 618.763 944.432 618.184 945.025C617.604 945.618 616.913 945.987 616.109 946.128C615.02 946.318 613.947 946.042 612.889 945.298C611.831 944.555 611.189 943.535 610.963 942.24C610.835 941.509 610.848 940.752 611.005 939.969L621.843 886.458C622.072 885.257 622.573 884.285 623.346 883.541C624.119 882.796 625.001 882.337 625.995 882.163C626.99 881.989 627.975 882.123 628.957 882.559C629.935 882.998 630.737 883.742 631.361 884.793L659.801 931.442C660.213 932.123 660.483 932.832 660.611 933.562ZM642.035 918.182L628.269 894.737L623.283 921.46L642.035 918.182Z"
		fill="#5E1286"
	/>
	<path
		d="M682.448 877.48L689.054 915.233C693.755 937.608 660.571 940.288 657.803 920.163C657.927 918.093 660.965 917.633 662.259 919.045C665.247 923.653 678.896 929.17 678.179 917.134C678.179 917.134 675.274 888.547 671.572 879.38C667.87 870.213 681.348 867.616 682.448 877.48Z"
		fill="#5E1286"
	/>
	<path
		d="M251.51 393.432C187.267 316.149 159.549 267.705 152.918 154.905L295.775 306.479L251.51 393.432Z"
		fill="#824B2E"
	/>
	<path
		d="M271.63 183.89L152.918 154.905C181.467 214.378 278.169 320.259 292.757 311.231C307.345 302.203 392.858 201.945 392.858 201.945L271.63 183.89Z"
		fill="#0A0A0A"
	/>
	<path
		d="M998.994 424.317C996.978 177.311 970.728 83.3854 876.258 0.480469C880.843 192.369 905.936 330.712 905.936 330.712C905.936 330.712 976.484 405.482 998.994 424.317Z"
		fill="#824B2E"
	/>
	<path
		d="M251.005 395.808L292.253 311.231L389.335 200.52L404.929 192.918L419.013 183.415C419.013 183.415 424.547 175.812 419.013 175.812C413.48 175.812 407.444 177.713 407.444 177.713L392.353 181.514L377.263 186.266C377.263 186.266 374.748 187.216 373.742 186.266C372.736 185.316 373.742 181.514 373.742 181.514L375.754 178.188C375.754 178.188 380.281 174.387 383.299 172.961C386.317 171.536 434.104 154.906 446.176 151.58C458.249 148.253 471.83 147.778 486.921 147.303C502.011 146.828 518.611 147.303 519.617 147.303C520.623 147.303 520.623 145.402 520.623 145.402C520.623 145.402 520.623 144.452 519.617 143.502C518.611 142.552 475.351 142.552 474.345 142.076C473.339 141.601 469.818 141.126 469.818 141.126C469.818 141.126 463.782 140.176 463.279 139.701C462.776 139.226 461.77 136.375 463.279 134.474C464.788 132.573 467.806 133.049 468.812 131.623C469.818 130.198 476.861 128.772 476.861 128.772L579.979 131.623L618.209 139.701L664.989 155.381L710.764 177.713H724.848L759.557 160.607L800.301 127.347L837.021 71.7538C837.021 71.7538 871.73 0.48084 875.754 0.00568663C879.778 -0.469467 895.372 28.99 895.372 28.99L914.989 77.4557L928.068 166.784L932.092 238.533L936.619 351.619L999.999 423.367V426.218H997.484L967.806 399.609L986.418 467.556L999.999 535.028L989.939 545.006L939.134 577.792V580.168L955.734 576.366L967.806 574.466H982.897C989.939 574.466 982.897 586.82 982.897 586.82C982.897 586.82 787.528 779.682 737.424 809.191C687.32 838.701 605.712 853.059 520.12 873.812H494.969C458.28 870.267 438.327 865.974 403.923 853.856C338.537 822.484 300.262 796.432 229.879 738.869L193.158 692.779L167.504 652.866C156.337 632.916 154.929 624.832 155.432 622.456C155.935 620.08 164.989 610.102 176.056 590.621L193.158 559.736L251.005 395.808Z"
		fill="black"
	/>
	<path
		d="M688.129 628.633C814.203 648.155 869.431 684.832 954.729 774.03C865.03 686.926 809.11 649.904 687.123 630.533L688.129 628.633Z"
		fill="white"
	/>
	<path
		d="M653.232 658.567C755.608 678.089 800.455 714.767 869.719 803.964C796.881 716.861 751.472 679.838 652.415 660.468L653.232 658.567Z"
		fill="white"
	/>
	<path
		d="M648.928 708.934C716.231 723.224 745.713 750.073 791.248 815.368C743.364 751.606 713.512 724.504 648.391 710.325L648.928 708.934Z"
		fill="white"
	/>
	<path
		d="M768.613 465.655C768.613 404.361 686.118 341.456 626.258 354.47C562.878 368.249 526.009 454.574 527.667 498.441C527.503 548.232 560.866 570.374 626.258 572.565C697.184 574.941 768.613 526.95 768.613 465.655Z"
		fill="#C9F180"
	/>
	<path
		d="M641.731 353.504C565.067 363.907 557.728 542.094 620.027 538.77C682.326 535.446 718.395 343.1 641.731 353.504Z"
		fill="black"
	/>
	<ellipse cx="652.042" cy="496.652" rx="7.04225" ry="6.65214" fill="white" />
	<path
		d="M349.597 372.05C304.828 372.05 270.623 437.621 279.174 505.568C285.716 542.818 308.913 562.545 349.597 556.884C421.961 536.249 414.157 372.05 349.597 372.05Z"
		fill="#C9F180"
	/>
	<path
		d="M347.082 372.05C291.75 377.752 279.679 538.353 324.447 538.354C369.215 538.354 402.415 366.348 347.082 372.05Z"
		fill="black"
	/>
	<ellipse cx="346.579" cy="496.541" rx="7.04225" ry="6.65214" fill="white" />
	<path
		d="M266.6 607.252C140.526 626.774 85.2972 663.451 0 752.649C89.6983 665.545 145.619 628.523 267.606 609.153L266.6 607.252Z"
		fill="white"
	/>
	<path
		d="M301.497 637.187C199.121 656.708 154.274 693.386 85.0098 782.583C157.847 695.48 203.256 658.457 302.314 639.087L301.497 637.187Z"
		fill="white"
	/>
	<path
		d="M305.801 687.553C238.498 701.843 209.015 728.692 163.48 793.987C211.365 730.225 241.217 703.123 306.338 688.944L305.801 687.553Z"
		fill="white"
	/>
	<path
		d="M425.818 722.617L431.812 658.722L424.797 658.135L418.804 722.03C402.359 742.756 383.177 741.23 332.444 716.711C331.079 716.091 330.574 719.074 332.444 720.661C334.315 722.249 350 730.278 368.254 737.265C386.509 744.253 399.945 740.333 399.945 740.333C399.945 740.333 417.96 731.023 419.641 729.256C421.322 727.488 423.827 727.698 425.152 729.717C426.478 731.736 439.18 741.615 444.21 743.017C449.24 744.419 470.452 747.242 478.415 746.32C486.378 745.398 508.429 740.98 515.342 737.265C522.256 733.551 524.079 728.19 515.831 732.059C507.582 735.929 441.963 753.54 425.818 722.617Z"
		fill="white"
	/>
	<path
		d="M466.306 608.241C454.242 607.819 431.119 619.848 425.627 618.705C420.135 617.562 398.725 598.744 392.413 605.656C386.102 612.567 395.206 624.297 395.206 624.297C415.219 653.051 411.63 648.524 424.044 659.065L433.092 659.382C433.092 659.382 469.322 634.023 474.628 627.076C479.934 620.129 478.37 608.663 466.306 608.241Z"
		fill="#FFCDCF"
	/>
</svg>
